import { useState, useEffect } from 'react';

// Détecte la préférence système
function getSystemTheme() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

// Récupère le thème sauvegardé ou utilise la préférence système
function getInitialTheme() {
  const saved = localStorage.getItem('ebios_theme');
  return saved || getSystemTheme();
}

export function useTheme() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    // Applique le thème sur <html>
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('ebios_theme', theme);
  }, [theme]);

  // Écoute les changements de préférence système
  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => {
      if (!localStorage.getItem('ebios_theme')) {
        setTheme(e.matches ? 'dark' : 'light');
      }
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const toggle = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return { theme, toggle, isDark: theme === 'dark' };
}
